import { parseISO } from 'date-fns';

export function convertStringToDate(
  date: string | null | undefined,
): Date | null {
  if (date === undefined || date === null) return null;

  return parseISO(date);
}
